/**
 * Navegación principal de la landing.
 *
 * Mantiene una experiencia simple:
 * - anclas para secciones públicas,
 * - enlace a tienda externa,
 * - acceso al área privada si existe sesión.
 */
import React, { useState } from "react";
import "./Navbar.scss";
import { useAuth } from "../context/AuthContext";

const Navbar = () => {
  const { currentUser } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Al hacer clic en un enlace se cierra el menú en móvil
  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/assets/images/logoBlanco.png" alt="Mentfull Logo" />
      </div>

      <div className="hamburger" onClick={toggleMobileMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      <ul className={`navbar-menu ${mobileMenuOpen ? "open" : ""}`}>
        <li>
          <a href="#nosotras" onClick={handleLinkClick}>
            Nosotras
          </a>
        </li>
        <li>
          <a href="#membresias" onClick={handleLinkClick}>
            Membresías
          </a>
        </li>
        <li>
          <a href="#instalar" onClick={handleLinkClick}>
            Instala la app
          </a>
        </li>
        <li>
          <a href="#contacto" onClick={handleLinkClick}>
            Contacto
          </a>
        </li>
        <li>
          <a href="https://fullwear.mx" onClick={handleLinkClick}>
            Tienda
          </a>
        </li>
        <li>
          {currentUser ? (
            <a href="dashboard" onClick={handleLinkClick}>
              |&nbsp;&nbsp;
              <img src="/assets/images/icoUser.png" alt="Socios Mentfull" />
            </a>
          ) : (
            <a href="login" onClick={handleLinkClick}>
              |&nbsp;&nbsp;
              <img src="/assets/images/icoUser.png" alt="Socios Mentfull" />
            </a>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
